import React, { useState } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  AlertDialogHeader,
  Button
} from '@apex/component-library'
import { Stack, Box, UnorderedList, ListItem, OrderedList } from '@chakra-ui/react'

const ScheduleTransfersInstructions = () => {
  const [showInstructions, setShowInstructions] = useState(false)

  const cancelRef = React.useRef<HTMLButtonElement>(null)

  const handleInstructionsClick = () => setShowInstructions(true)

  const handleAlertClose = () => {
    setShowInstructions(false)
  }

  return (
    <>
      <Box>
        <Button onClick={handleInstructionsClick} variant='link' fontWeight='400'>
          Creating Scheduled Transfers
        </Button>
      </Box>

      <AlertDialog
        isCentered
        isOpen={showInstructions}
        leastDestructiveRef={cancelRef}
        motionPreset='slideInBottom'
        onClose={handleAlertClose}
        size='2xl'
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Creating Scheduled Transfers</AlertDialogHeader>
            <AlertDialogBody>
              <Stack>
                <Box>
                  <UnorderedList paddingLeft={2} spacing={2}>
                    <ListItem>
                      To set a specific day of the week for a transfer, select a corresponding start date on that
                      weekday. For example, for every Monday, specify a start date that is a Monday.
                    </ListItem>
                    <ListItem>
                      To set-up a recurring transfer for the 1st day of the month, select the first day of the next
                      month: MM/01/YYYY. Likewise, if you schedule a monthly transfer on the 31st, you’re effectively
                      scheduling it on the last day of the month for all future occurrences.
                    </ListItem>
                    <ListItem>
                      To create transfers on the 1st & 15th of the month, create two separate transfer schedules:
                    </ListItem>
                    <OrderedList>
                      <ListItem>One that is monthly and occurs on the 1st</ListItem>
                      <ListItem>One that is monthly and occurs on the 15th</ListItem>
                    </OrderedList>
                    <ListItem>
                      Define a number of transfers if you wish to limit the number of occurrences. If a value is not
                      specified, the schedule continues indefinitely. Once the number of transfers is met, the schedule
                      series will be complete.
                    </ListItem>
                    <ListItem>
                      If you specify today as the Start Date and the request is submitted during the processing window,
                      the first transfer is submitted on the same day.
                    </ListItem>
                    <ListItem>
                      Scheduled transfers must be canceled the day before the next transfer day to be processed.
                    </ListItem>
                  </UnorderedList>
                </Box>
              </Stack>
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button variant='outline' ref={cancelRef} onClick={handleAlertClose}>
                Close
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}

export default ScheduleTransfersInstructions
